import { useEffect, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";

import "./index.scss";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import {
  addPDMCurriculamTimeline,
  addPDMSummit,
  getPDMCurriculamTimeline,
  getPDMSummit,
} from "../../../store/features/AdminPanel/Setting/ProductPageSubtitles/ProductPageSubtitesAPi";
import { PrimaryButton } from "../../../shared/Buttons/Buttons";

const ProductPageSubtitlesTabContent = () => {
  const editor = useRef(null);
  const pdmTimelineEditor = useRef(null);
  const dispatch = useAppDispatch();
  const [content, setContent] = useState("");
  const [curriculamTimelineContent, setCurriculamTimeLineContent] =
    useState("");

  const ProductPageSubtitlesState: any = useAppSelector((store: RootStore) => {
    return store.ProductPageSubtitlesSlice;
  });
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const config: any = useMemo(
    () => ({
      readonly: false,
      height: "300px",
      width: "100%",
      buttons: [
        "source",
        "|",
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "table",
        "link",
        "|",
        "left",
        "center",
        "right",
        "justify",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "fullsize",
      ],
      removeButtons: [
        "brush",
        "file",
        "eraser",
        "hr",
        "redo",
        "undo",
        "justify",
        "right",
        "center",
        "justify",
        "left",
        "link",
        "table",
        "image",
        "paragraph",
        "brush",
        "fontsize",
        "font",
        "source",
        "fullsize",
        "|",
      ],
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: true,
      toolbarAdaptive: false,
      toolbarSticky: false,
      spellcheck: true,
      theme: themeState.themeMode === "dark" ? "dark" : "default",
      i18n: "en",
      // limitWords: 3,
      // autofocus: true,
      // cursorAfterAutofocus: "end",
      // saveSelectionOnBlur: true,
      style: {
        fontFamily: "Montserrat !important",
        textAlign: "justify",
      },
    }),
    []
  );

  function sanitizeContent(content: string) {
    if (!content || content.trim() === "" || content.trim() === "<p><br></p>") {
      return null;
    }
    return content;
  }

  useEffect(() => {
    dispatch(getPDMSummit());
    dispatch(getPDMCurriculamTimeline());
  }, []);
console.log(ProductPageSubtitlesState);
  useEffect(() => {
    if (ProductPageSubtitlesState.req_success.add_summit) {
      setContent(ProductPageSubtitlesState?.pdm_summit?.content);
    }
  }, [ProductPageSubtitlesState.req_success.add_summit]);
  useEffect(() => {
    if (ProductPageSubtitlesState.req_success.add_timeline) {
      setCurriculamTimeLineContent(
        ProductPageSubtitlesState?.pdm_timeline?.content
      );
    }
  }, [ProductPageSubtitlesState.req_success.add_timeline]);
  const submitContent = () => {
    dispatch(addPDMSummit({ data: sanitizeContent(content) }));
  };
  const submitpdmTImelineContent = () => {
    dispatch(
      addPDMCurriculamTimeline({
        data: sanitizeContent(curriculamTimelineContent),
      })
    );
  };
  return (
    <div className="terms_container terms_container__margin_handle ">
      <span className="company__setting">Program Page Content</span>
      <div>
        <span className="company__setting__title">
          The Product Management Summit
        </span>
        <div className="editor-wrapper">
          <JoditEditor
            ref={editor}
            value={content}
            config={config}
            onBlur={(newContent) => setContent(newContent)}
          />
        </div>
        <div className="button_sec">
          <PrimaryButton
            style={{ width: "10rem" }}
            text="Submit"
            label="Submit"
            loading={ProductPageSubtitlesState.loading.add_summit}
            onClick={submitContent}
          />
        </div>
      </div>
      <div>
        <span className="company__setting__title">
          Product Management Curriculum Timeline
        </span>
        <div className="editor-wrapper">
          <JoditEditor
            ref={pdmTimelineEditor}
            value={curriculamTimelineContent}
            config={config}
            onBlur={(newContent) => setCurriculamTimeLineContent(newContent)}
          />
        </div>
        <div className="button_sec">
          <PrimaryButton
            style={{ width: "10rem" }}
            text="Submit"
            label="Submit"
            loading={ProductPageSubtitlesState.loading.add_timeline}
            onClick={submitpdmTImelineContent}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductPageSubtitlesTabContent;
